export const trimPath = (path: string) => {
  return path.split("/")[path.split("/").length - 1];
};
